import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import AboutSection from "./components/AboutSection";
import CategoriesGrid from "./components/CategoriesGrid";
import TrustSection from "./components/TrustSection";
import BlogSection from "./components/BlogSection";
import ReviewsSection from "./components/ReviewsSection";
import CTASection from "./components/CTASection";
import FAQSection from "./components/FAQSection";

const SITE_URL = import.meta.env.VITE_SITE_URL || "https://kakobuyspreadsheet.website";
const FAVICON_URL = "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/9f7209ca9e1d80750ccbea8c559f256f.png";

const homeSchema = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  "name": "Best Kakobuy Spreadsheet 2026 | Trusted Sellers & Verified Finds",
  "description": "Discover the best Kakobuy Spreadsheet with 500+ trusted sellers, 20,000+ verified products, QC guides, shipping tips, and weekly updated shopping resources.",
  "url": SITE_URL + "/",
  "dateModified": "2026-06-25",
  "publisher": {
    "@type": "Organization",
    "name": "Kakobuy Spreadsheet",
    "logo": {
      "@type": "ImageObject",
      "url": FAVICON_URL
    }
  },
  "mainEntity": {
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "What is a Kakobuy Spreadsheet?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "A Kakobuy Spreadsheet is a curated, regularly updated resource that lists verified product finds, trusted sellers, quality control information, and shopping guides for the Kakobuy platform."
        }
      },
      {
        "@type": "Question",
        "name": "How often is the Kakobuy Spreadsheet updated?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Our Kakobuy Spreadsheet is updated on a weekly basis with new verified product finds, seller reputation reviews, and refreshed buying guides."
        }
      },
      {
        "@type": "Question",
        "name": "Are the sellers in the spreadsheet verified?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes. Every seller undergoes a verification process including checking seller history, buyer feedback, response rates, and product quality consistency."
        }
      },
      {
        "@type": "Question",
        "name": "How do I use the Kakobuy Spreadsheet to find products?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Simply browse by category using our navigation dropdown or category cards. Each entry links directly to the product or seller page on Kakobuy."
        }
      },
      {
        "@type": "Question",
        "name": "Is the Kakobuy Spreadsheet free to use?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Absolutely. Our Kakobuy Spreadsheet is completely free to access without any paywalls or subscription requirements."
        }
      }
    ]
  }
};

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(homeSchema),
        }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <AboutSection />
        <CategoriesGrid />
        <TrustSection />
        <BlogSection />
        <ReviewsSection />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}